import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import { ValuesSchemaType, OperatorType } from "../../schemas";
import { MobileFilterCheckboxList } from "../MobileFilterCheckboxList/MobileFilterCheckboxList";
import { useTranslations } from "next-intl";
import { useMobileFilterCategorySheet } from "./useMobileFilterCategorySheet";
type Props = {
  pageKey: string;
  filterId: string;
  availableValues: ValuesSchemaType;
  operatorOptions: OperatorType["values"];
};
export function MobileFilterCategorySheet(t0) {
  const $ = _c(16);
  const {
    pageKey,
    filterId,
    availableValues,
    operatorOptions
  } = t0;
  const t = useTranslations("modules.listings.listingsPage.filters");
  const {
    activeValues,
    inactiveValues,
    currentOperator,
    hasActiveValues,
    handleToggle,
    handleSetOperator,
    handleClear
  } = useMobileFilterCategorySheet(pageKey, filterId, availableValues);
  let t1;
  if ($[0] !== currentOperator || $[1] !== handleSetOperator || $[2] !== operatorOptions) {
    t1 = operatorOptions.length > 0 && <div className="flex gap-2 px-4 py-3 border-b">{operatorOptions.map(op => <button key={op.value} onClick={() => handleSetOperator(op.value)} className={cn("flex-1 py-2 rounded-full text-sm border transition-colors", op.value === currentOperator ? "bg-zinc-900 text-white border-zinc-900" : "bg-white text-zinc-600 border-zinc-300")}>{op.label}</button>)}</div>;
    $[0] = currentOperator;
    $[1] = handleSetOperator;
    $[2] = operatorOptions;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== activeValues || $[5] !== handleToggle || $[6] !== inactiveValues) {
    t2 = <div className="flex-1 min-h-0 overflow-y-auto scrollbar-none"><MobileFilterCheckboxList activeValues={activeValues} inactiveValues={inactiveValues} onChange={handleToggle} data-sentry-element="MobileFilterCheckboxList" data-sentry-source-file="MobileFilterCategorySheet.tsx" /></div>;
    $[4] = activeValues;
    $[5] = handleToggle;
    $[6] = inactiveValues;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== handleClear || $[9] !== hasActiveValues || $[10] !== t) {
    t3 = hasActiveValues && <div className="sticky bottom-0 p-4 border-t bg-white"><button onClick={handleClear} className="w-full py-3 rounded-full bg-zinc-900 text-white text-sm font-medium">{t("clearFilter")}</button></div>;
    $[8] = handleClear;
    $[9] = hasActiveValues;
    $[10] = t;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== t3) {
    t4 = <div className="flex flex-1 min-h-0 flex-col" data-sentry-component="MobileFilterCategorySheet" data-sentry-source-file="MobileFilterCategorySheet.tsx">{t1}{t2}{t3}</div>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}